import Account                from './account';
import Chapter                from './chapter';

export default class LocalAuthorityChapterAccount {
	/**
	 * @param {Number}         id
	 * @param {Chapter}        chapter 
	 * @param {Account}        account 
	 */
	constructor(id, chapter, account) {
		this.account        = account;
		this.chapter        = chapter;
		this.id             = id;
	}

	static createFromJson = (json) => {
		if (!json) return null;

		return new LocalAuthorityChapterAccount(
			json.id,
			json.chapter,
			json.account
		)
	}
}


// WEBPACK FOOTER //
// ./src/model/local-authority-chapter-account.js